import { ModalOptions } from "ngx-bootstrap";
import { NavigationMode, TriggerAction } from "./enums";
import { ConfigService } from "../services/config.service";

export class ModalOption implements ModalOptions {
  constructor(_class: string = "modal-lg") {
    this.class = _class;
  }

  backdrop? = true;
  keyboard? = false;
  focus? = true;
  show? = false;
  ignoreBackdropClick? = true;
  animated? = true;
  class?: string;
  initialState?: Object;

  set(options: ModalOptions) {
    Object.assign(this, options);
  }
}

// export class ModalRef extends BsModalRef {
//    modalFormService: any;
// }

export interface INavigateAction {
  openWith?: NavigationMode;
  route?: any[];
}

export class NavigateOptions {
  add?: {
    openWith?: NavigationMode;
    route?: any[];
  };

  edit: {
    openWith?: NavigationMode;
    route?: any[];
  };

  added: {
    route?: any[];
  };

  edited: {
    route?: any[];
  };

  default: any[];

  set(action: string, options: INavigateAction) {
    if (!this[action]) {
      throw Error("action do not exist");
    }
    Object.assign(this[action], options);
  }
}

export class ModalTriggerOpts {
  triggeredMethod?: string;
  IsShown: boolean;
  model: any;
  cancel: boolean;
  private _internalAction = TriggerAction.none;

  get action(): TriggerAction {
    return this._internalAction;
  }

  set action(value: TriggerAction) {
    this._internalAction = value;
    this.IsShown = this._internalAction == TriggerAction.open;
  }

  // open(model?:any): ModalTriggerOpts {
  //   this.action = TriggerAction.open;
  //   this.model = model;
  //   return this;
  // }

  // close(model?:any): ModalTriggerOpts {
  //   this.action = TriggerAction.close;
  //   this.model = model;
  //   return this;
  // }

  set(action: TriggerAction, cancel = false, model?: any): ModalTriggerOpts {
    this.action = action;
    this.cancel = cancel;
    this.model = model;

    return this;
  }
}

export class BlockerManager {
  private _config: ConfigService;

  constructor(config: ConfigService) {
    this._config = config;
  }

  turnOff(once?: boolean): BlockerManager {
    if (!this._config) return this;

    if (once) this._config.GlobalOptions.blocker.turnOffOnce = true;
    else this._config.GlobalOptions.blocker.turnOff = true;
    return this;
  }

  turnOn() {
    if (!this._config) return this;

    this._config.GlobalOptions.blocker.turnOff = false;
    return this;
  }

  show() {
    this._config.blocker = true;
  }

  hide() {
    this._config.blocker = false;
  }
}
